import workspaceQuery from '../../queries/supplier/SupplierPriceListWorkspaceQuery.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const SupplierPriceList: EntityType = {
  type: 'SupplierPriceWork',
  title: 'Supplier Price List',
  defaultReturnUrl: '/menu/Suppliers/',
  workspace: workspaceQuery,
  workspaceUrl: '/Suppliers/SupplierPriceList/Workspace',
  screenReference: 'SUPPLIER_PRICE_LIST',
  operations: ALLOW_VIEW,
};

export default SupplierPriceList;
